import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const GoogleDrive = (props: TIconProps): ReactElement => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#googledrive_clip0_439_72838)">
      <path
        d="M1.73883 17.141L2.75315 18.8461C2.96392 19.2051 3.2669 19.4872 3.62257 19.6923L7.24513 13.5897H0C0 13.9872 0.105384 14.3846 0.316151 14.7436L1.73883 17.141Z"
        fill="hsl(from hsl(217 89% 61%) h s 38%)"
      />
      <path
        d="M11.5 6.41024L7.87743 0.307678C7.52176 0.512806 7.21879 0.794858 7.00802 1.15383L0.316151 12.4359C0.10926 12.7871 0.000275463 13.1849 0 13.5897H7.24513L11.5 6.41024Z"
        fill="hsl(from hsl(217 89% 61%) h s 48%)"
      />
      <path
        d="M19.3775 19.6923C19.7332 19.4872 20.0361 19.2051 20.2469 18.8461L20.6684 18.141L22.6839 14.7436C22.8947 14.3846 23.0001 13.9872 23.0001 13.5897H15.7544L17.2962 16.5384L19.3775 19.6923Z"
        fill="hsl(from hsl(217 89% 61%) h s 50%)"
      />
      <path
        d="M11.5 6.41026L15.1226 0.307692C14.7669 0.102564 14.3585 0 13.937 0H9.06301C8.64147 0 8.23311 0.115385 7.87744 0.307692L11.5 6.41026Z"
        fill="hsl(from hsl(217 89% 61%) h s 37%)"
      />
      <path
        d="M15.7549 13.5897H7.24512L3.62256 19.6923C3.97823 19.8974 4.38659 20 4.80813 20H18.1919C18.6134 20 19.0218 19.8846 19.3774 19.6923L15.7549 13.5897Z"
        fill="hsl(from hsl(217 89% 61%) h s 51%)"
      />
      <path
        d="M19.3379 6.79486L15.992 1.15383C15.7812 0.794858 15.4782 0.512806 15.1226 0.307678L11.5 6.41024L15.7549 13.5897H22.9868C22.9868 13.1923 22.8814 12.7949 22.6707 12.4359L19.3379 6.79486Z"
        fill="hsl(from hsl(217 89% 61%) h s 76%)"
      />
    </g>
    <defs>
      <clipPath id="googledrive_clip0_439_72838">
        <rect width="23" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
